import { compose } from 'recompose';

import apiInterceptor from '../../../api/interceptor';
import {
  buApi, ledgerApi, jvApi
} from '../../common/base.api';
import CreateContraEntry from './CreateContraEntry';

const composedCreateContraEntry = compose(
  apiInterceptor({
    ...buApi,
    create: { ...jvApi },
    getList: { ledgerApi },
  }),
)(CreateContraEntry);

export default composedCreateContraEntry;
